/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function packageProtection() {
  $("body").on("change", "[data-package-protection]", function (e) {
    e.preventDefault();
    if ($(this).is(":checked")) {
      var params = {
        type: "POST",
        url: "/cart/add.js",
        data:
          "quantity=" +
          1 +
          "&properties[package]=true&id=" +
          $(this).attr("data-package-protection"),
        dataType: "json",
        success: function (line_item) {
          console.log("Added product!");
        },
        error: function (XMLHttpRequest, textStatus) {
          alert("Product currently not available!");
        },
      };
      jQuery.ajax(params);
      return false;
    } else {
      var params = {
        type: "POST",
        url: "/cart/change.js",
        data:
          "quantity=" + 0 + "&id=" + $(this).attr("data-package-protection"),
        dataType: "json",
        success: function (line_item) {
          console.log("Removed product!");
        },
        error: function (XMLHttpRequest, textStatus) {
          console.log("Error Occurred!");
        },
      };
      jQuery.ajax(params);
      return false;
    }
  });
}
packageProtection();
